import { atom } from 'jotai';

export const isQuickSettingsOpenAtom = atom(false);